import { AbsenceOccurrence } from '../../../types/absence'

interface Props {
  employee: AbsenceOccurrence['employeeResponse']
}

function EmployeeSection({ employee }: Props) {
  return (
    <>
      <h3>Name</h3>
      <p>{employee.displayName}</p>
      <br />
    </>
  )
}

export default EmployeeSection